import { RequestMethod } from '../interfaces/typesAPI';
import Utils from '../utils/utils';
import API from './api';
export default class UserStatistics {
    static async get(userId) {
        const responseData = await API.sendRequest(Utils.buildLink(['users', userId, 'statistics']), RequestMethod.GET, undefined, true);
        const returnData = responseData
            ? {
                learnedWords: responseData.learnedWords,
                optional: {
                    startDate: responseData.optional.startDate,
                    sprintStreakPerDay: JSON.parse(responseData.optional.sprintStreakPerDay),
                    audioStreakPerDay: JSON.parse(responseData.optional.audioStreakPerDay),
                    newWordsPerDay: JSON.parse(responseData.optional.newWordsPerDay),
                    learnedWordsPerDay: JSON.parse(responseData.optional.learnedWordsPerDay),
                    learnedWordsList: JSON.parse(responseData.optional.learnedWordsList),
                    seenWordsList: JSON.parse(responseData.optional.seenWordsList),
                },
            }
            : undefined;
        return returnData;
    }
    static async update(userId, statisticsData) {
        // console.warn(statisticsData.optional.newWordsPerDay);
        // console.warn(JSON.stringify(statisticsData.optional.newWordsPerDay));
        const responseData = await API.sendRequest(Utils.buildLink(['users', userId, 'statistics']), RequestMethod.PUT, {
            learnedWords: statisticsData.learnedWords,
            optional: {
                startDate: statisticsData.optional.startDate,
                sprintStreakPerDay: JSON.stringify(statisticsData.optional.sprintStreakPerDay),
                audioStreakPerDay: JSON.stringify(statisticsData.optional.audioStreakPerDay),
                newWordsPerDay: JSON.stringify(statisticsData.optional.newWordsPerDay),
                learnedWordsPerDay: JSON.stringify(statisticsData.optional.learnedWordsPerDay),
                learnedWordsList: JSON.stringify(statisticsData.optional.learnedWordsList),
                seenWordsList: JSON.stringify(statisticsData.optional.seenWordsList),
            },
        }, true);
        return responseData;
    }
}
